import { createSelector } from 'reselect';
const userStateSelector = (state) => state.user;
export const userCoreStateSelector = createSelector(userStateSelector, (user) => user.core);
export const uploadProfilePictureSelector = createSelector(userCoreStateSelector, (core) => core.uploadProfilePicture);
export const profilePictureHasBeenUploadedSelector = createSelector(uploadProfilePictureSelector, (uploadProfilePicture) => uploadProfilePicture.hasBeenUploaded);
export const uploadProfilePictureErrorSelector = createSelector(uploadProfilePictureSelector, (uploadProfilePicture) => uploadProfilePicture.error);
export const uploadProfilePictureIsLoadingSelector = createSelector(uploadProfilePictureSelector, (uploadProfilePicture) => uploadProfilePicture.isLoading);
export default {
    profilePictureHasBeenUploadedSelector,
    uploadProfilePictureErrorSelector,
    uploadProfilePictureIsLoadingSelector,
};
